import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ComplexNumberInput.css';
import Number from 'components/shared/text/Number';
import Button from 'components/shared/button/Button';

class ComplexNumberInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(['blue', 'tomato']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onValueBlur: PropTypes.func,
    onValueChange: PropTypes.func,
  };

  static defaultProps = {
    theme: 'tomato',
    value: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      showInput: false,
    };
    this.inputRef = null;
  }

  componentDidUpdate() {
    if (this.inputRef !== null) {
      this.inputRef.focus();
    }
  }

  render() {
    let component;
    if (this.state.showInput) {
      component = (
        <div className="value-input">
          <span>{this.props.label}</span>
          <input
            ref={(input) => {
              this.inputRef = input;
            }}
            value={this.props.value !== null ? this.props.value : ''}
            type="number"
            onBlur={this.handleInputBlur}
            onChange={this.handleInputChange}
          />
        </div>
      );
    } else if (this.props.value === null) {
      component = (
        <Button
          className={
            this.props.theme === 'blue' ? 'button-blue-grey' : 'button-orange'
          }
          label={`Add ${this.props.label}...`}
          onClick={this.handleAddInputClick}
        />
      );
    } else {
      component = (
        <div
          className={`value-readonly ${this.props.theme}`}
          onClick={this.handleAddInputClick}
        >
          <div>
            {this.props.label}{' '}
            <Number value={this.props.value} format="$0,0.00" />
          </div>
        </div>
      );
    }

    return <div className="complex-number-input">{component}</div>;
  }

  handleAddInputClick = () => {
    this.setState({
      showInput: true,
    });
  };

  handleInputBlur = (event) => {
    event.preventDefault();

    // Firefox issue - check: https://tirdadc.github.io/blog/2015/06/11/react-dot-js-firefox-issue-with-onblur/
    if (
      event.nativeEvent.explicitOriginalTarget &&
      event.nativeEvent.explicitOriginalTarget ===
        event.nativeEvent.originalTarget
    ) {
      return;
    }

    this.setState({
      showInput: false,
    });

    if (this.props.onValueBlur !== undefined) {
      this.props.onValueBlur(event.target.value);
    }
  };

  handleInputChange = (event) => {
    if (this.props.onValueChange !== undefined) {
      this.props.onValueChange(event.target.value);
    }
  };
}

export default ComplexNumberInput;



// WEBPACK FOOTER //
// ./src/components/shared/input/ComplexNumberInput.js